"use client";

import { c as _c } from "react/compiler-runtime";
import { createContext, useContext, useReducer, type ReactNode } from "react";
import { initialLoginState, loginReducer, type LoginAction, type LoginState } from "./reducer";
export type LoginDispatch = (action: LoginAction) => void;
type LoginContextType = [LoginState, LoginDispatch];
export const LoginContext = createContext<LoginContextType | undefined>(undefined);
export const useLogin = () => {
  return useContext(LoginContext);
};
interface LoginProviderProps {
  children: ReactNode;
}
export function LoginProvider(t0) {
  const $ = _c(5);
  const {
    children
  } = t0;
  const [state, dispatch] = useReducer(loginReducer, initialLoginState);
  let t1;
  if ($[0] !== state) {
    t1 = [state, dispatch];
    $[0] = state;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <LoginContext.Provider value={t1}>{children}</LoginContext.Provider>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}